import validator from "validator";
import {
  isBefore,
  isNotBeforeDate,
  isContainLower,
  isContainSpecialChar,
  isContainUpper,
  isInTheFuture,
  isOnlyDigits,
  beforeToday,
  isValidNigerianPhoneNumber,
} from "./isContain";

export function validateData(value: string, rules: any, formValues: any) {
  let validInput = true;
  let errorMessages: any[] = [];

  if (!rules) {
    validInput = true;

    //Come back later
    return { isValid: validInput, errorMessages };
  }

  Object.keys(rules).forEach((ruleKey) => {
    switch (ruleKey) {
      case "maxLength":
        if (value.length > rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }

        break;

      case "minLength":
        if (value.length < rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "length":
        if (value.length !== rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;
      case "contains":
        if (!validator.contains(value, rules[ruleKey].expectedValue)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }

        break;

      case "isEmail":
        if (!(validator.isEmail(value) === rules[ruleKey].expectedValue)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }

        break;

      case "compareWithExisting":
        if (!(formValues[rules[ruleKey].expectedValue] === value)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "validNigerianPhoneNumber":
        if (isValidNigerianPhoneNumber(value) !== rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "containSpecialChar":
        if (!isContainSpecialChar(value)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;
      case "containUppercase":
        if (!isContainUpper(value)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;
      case "containLowercase":
        if (!isContainLower(value)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;
      case "onlyDigit":
        if (!isOnlyDigits(value)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "notInTheFuture":
        if (isInTheFuture(value) === rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "notBefore":
        if (!isBefore(value, formValues[rules[ruleKey].expectedValue])) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      // MED-723: whole-calendar-day floor for date inputs, inclusive of the
      // boundary. `expectedValue` is a "YYYY-MM-DD" string. Use this rather
      // than `notBefore` for anything a date picker feeds: `notBefore` is a
      // strict timestamp `>`, which rejects the boundary day itself and, given
      // a timestamp boundary, rejects the day after it too.
      case "notBeforeDate":
        if (!isNotBeforeDate(value, rules[ruleKey].expectedValue)) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "imageType":
        // @ts-ignore
        if (value && value["type"].split("/")[0] !== "image") {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "maxSize":
        // @ts-ignore
        if (value && value.size > rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "aboveZero":
        // @ts-ignore
        const isGreater = value > 0;
        if (isGreater !== rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      case "fromToday":
        // @ts-ignore
        if (beforeToday(value) === rules[ruleKey].expectedValue) {
          validInput = false;
          errorMessages.push(rules[ruleKey].errorMessage);
        }
        break;

      default:
        break;
    }
  });

  return { isValid: validInput, errorMessages };
}
